// Description: Request to get campaigns by account uuid
// Updated: 08/09/2025 

import axios from 'axios';
import { getTokenData } from '../../../shared/utils/utils';

export async function CampaignsByUuidAccount() {
    try {
        const { token, client_id } = await getTokenData();

        if (!token) throw new Error('Token de autenticação não encontrado');

        if (!client_id) throw new Error('ID do cliente não encontrado');
        const response = await axios.get(
            `${process.env.REACT_APP_BACKEND_AWS_URL}/campaigns/list`,
            { 
                headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': `${token}`,
                    'Client_ID': `${client_id}`
                },
            }
            
        );
        
        const responseData = response.data;
        return responseData;
    } catch (error) {
        console.error('Erro ao buscar dados da API:', error);
        // Melhor manejo do erro, exibindo mensagem de erro do servidor, se disponível
        const errorMsg = error.response?.data?.message || 'Erro desconhecido ao buscar dados da API';
        throw new Error(`Erro ao buscar dados da API: ${errorMsg}`);
    }
}

